import Player from './Player'
import PlayersJSON from '../data/teams.json'

const Players= ({title, setOpened, setNewPlayer}) =>{

return(
        <>
            {
                title === 'All' ?
                    //show all of the players
                    (PlayersJSON.players.map((player)=>(
                        <Player key={player.id} player={player} setOpened={setOpened} setNewPlayer={setNewPlayer}/>
                    )))
                    : 
                    ((title === 'Western Conference' || title === 'Eastern Conference') ?
                    //filter the players by conferences, positions, teams, names
                    (
                        PlayersJSON.players.map((player)=>(
                        player.team.conference === title &&
                        <Player key={player.id} player={player} setOpened={setOpened} setNewPlayer={setNewPlayer}/>
                    )))
                    :
                    (PlayersJSON.players.map((player)=>(
                        player.positions.map((position)=>
                            position === title &&
                            <Player key={player.pid} player={player} setOpened={setOpened} setNewPlayer={setNewPlayer}/>
                        ) 
                    )))
                    )
                    
            }
        </>
    )
}

export default Players